

import Native from 'c-up-native';
import Url from 'c-url';
import pkg from '../../package.json';

function getProjectVersion() {
    const version = pkg.version.split(".");
    version.splice(2, 0, '0')
    return version.join('.');
}

function getDefaultUA() {
    let system = Native.getSystem();
    let feature = Url.query('feature') || 0;
    let userAgent = '';

    if (Native.getPlatform() == 'uplive') {
        let ua = navigator.userAgent;
        let reg = /uplive\/(.*?)\s/i;
        let versionArr = reg.exec(ua);

        if (versionArr && versionArr[0]) {
            let version = versionArr[1];

            if (system == 'android') {
                userAgent = `Android/google version/${version} feature/${feature}`;
            } else {
                userAgent = `iOS/appstore version/${version} feature/${feature}`;
            }
        } else {
            userAgent = `H5/h5 version/${getProjectVersion()} feature/${feature}`;
        }

    } else {
        userAgent = `H5/h5 version/${getProjectVersion()} feature/${feature}`;
    }
    return userAgent;
}

export {
    getProjectVersion,
    getDefaultUA
}


// WEBPACK FOOTER //
// ./js/utils/tools.js